import React, { Component } from "react"
import PropTypes from "prop-types"

import { Row, Col } from 'react-bootstrap'
import {
  customerFieldsObject,
  getCustomerFullName,
  isCustomerDateField,
} from '../../lib/utils'
import FontAwesome from 'react-fontawesome'
import Authenticated from '../../lib/Authenticated'
import ClientDocuments from '../fragments/ClientDocuments'
import UpdateAffiliation from './UpdateAffiliation'
import CustomBreadCrumb from '../fragments/CustomBreadCrumb'
import moment from 'moment'
import SimpleCardRow from "../fragments/SimpleCardRow"
import LoanSmallCard from "../fragments/LoanSmallCard"
import BusinessLink from "../fragments/BusinessLink"

class CustomerForm extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    showUpdateAffiliate: false,
  }

  componentDidMount() {
    const { getCustomerLoans, customer } = this.props
    getCustomerLoans(customer.id)
  }

  renderValue = info => isCustomerDateField(info.type)
    ? ((Number(info.value) && !isNaN(info.value)) ? moment(Number(info.value)).format("LL") : '')
    : (info.type === customerFieldsObject.CHECKBOX ? ((info.value === 'true' || info.value === true) ? 'Yes' : 'No') : info.value)

  renderCustomerInfos = infos => {

    if(!infos || !infos.length) return null
    return infos.map((info, index) =>
      <SimpleCardRow key={index} name={ info.label } value={ this.renderValue(info) } />)
  }

  showRow = (name, value, className) =>
    <SimpleCardRow name={ name } value={ value } className={ className } />

  renderUpdateLink = className => {

    if (!this.isAdmin) return null
  
    return <span className={ `cursor-pointer ${ className }` }
      onClick={() => this.setState({ showUpdateAffiliate: true })}>
      <FontAwesome name="pencil" title='Update' />
    </span>
  }

  showCustomer = (customer, showUpdateAffiliate, businesses, setCustomer) => {

    if(!customer) return null

    const { id: customerId, business, fullName, firstName, lastName, phoneNumber,
      createdOn, infos, documents } = customer,
    businessLink = business
      ? <span>
          <BusinessLink id={business.id} name={business.name} businessId={business.businessId} />
          { this.renderUpdateLink('ml-10') }
        </span>
      : this.renderUpdateLink('')

    return <Col md={8} className='detail-content'>

      <h2 className="blue">
        { fullName }
      </h2>

      { this.showRow('First Name', firstName) }

      { this.showRow('Last Name', lastName) }

      { this.showRow('Phone Number', phoneNumber) }

      { this.showRow('Affiliated', businessLink) }

      { this.renderCustomerInfos(infos) }

      { this.showRow(
        'Created On',
        createdOn ? moment(createdOn).format('lll') : '',
        'gray font-size-13'
      )}

      <ClientDocuments documents={ documents } />

      <UpdateAffiliation
        show={ showUpdateAffiliate }
        close={() => this.setState({ showUpdateAffiliate: false })}
        fullName={ fullName }
        customerId={ customerId }
        businessId={ business ? business.id : '' }
        setCustomer={ setCustomer }
        businesses={ businesses }
      />
    </Col>
  }

  render() {
    const { customer, customerLoans, businesses, setCustomer } = this.props,
    { showUpdateAffiliate } = this.state,
    dataBreadCrumbs = [{ url: '/customers', title: 'Customers' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ getCustomerFullName(customer) } data={ dataBreadCrumbs } />

        <Row>
          <Col md={4}>

            <div className="align-center">
              <FontAwesome name="user" size="3x" className="detail-icon" />
            </div>
            <LoanSmallCard loans={ customerLoans } />
          </Col>
          { this.showCustomer(customer, showUpdateAffiliate, businesses, setCustomer) }
        </Row>
      </div>
    )
  }
}

CustomerForm.propTypes = {
  customer: PropTypes.object.isRequired,
}

export default CustomerForm



// WEBPACK FOOTER //
// ./src/components/Customers/Form.js